import type { MessageKey } from "../shell/i18n";

export type Showing = "mine" | "awaiting";

/** One pair of sent/approval screens and the exact processes belonging to it. */
export interface RequestSurface {
  readonly processes: readonly string[];
  readonly context: "leave" | "expense" | "advance" | "generic";
  readonly sent: MessageKey;
  readonly awaiting: MessageKey;
  readonly sentNothing: MessageKey;
  readonly nothingAwaits: MessageKey;
}

/** The existing decision console, scoped like the original module request table. */
export function requestInboxAt(surface: RequestSurface): string {
  if (surface.context === "leave") return "/inbox/tasks?module=leave";
  if (surface.context === "expense") return "/inbox/tasks?module=expense";
  if (surface.processes.length === 1)
    return `/inbox/tasks?process=${encodeURIComponent(surface.processes[0] ?? "")}`;
  return "/inbox/tasks";
}

export const LEAVE_REQUESTS: RequestSurface = {
  processes: [
    "people.leave_request",
    "people.leave_of_absence_request",
    "people.leave_cancellation",
    "people.past_leave_cancellation",
    "people.leave_configuration",
  ],
  context: "leave",
  sent: "requests.leave.heading",
  awaiting: "requests.leave.awaitingHeading",
  sentNothing: "requests.leave.sentNothing",
  nothingAwaits: "requests.leave.nothingAwaits",
};

export const EXPENSE_REQUESTS: RequestSurface = {
  processes: ["expense.claim", "expense.claim_review"],
  context: "expense",
  sent: "requests.expense.heading",
  awaiting: "requests.expense.awaitingHeading",
  sentNothing: "requests.expense.sentNothing",
  nothingAwaits: "requests.expense.nothingAwaits",
};

export const ADVANCE_REQUESTS: RequestSurface = {
  processes: ["advance.request"],
  context: "advance",
  sent: "requests.advance.heading",
  awaiting: "requests.advance.awaitingHeading",
  sentNothing: "requests.advance.sentNothing",
  nothingAwaits: "requests.advance.nothingAwaits",
};

export const TRAVEL_REQUESTS: RequestSurface = {
  processes: ["travel.request"],
  context: "generic",
  sent: "requests.travel.heading",
  awaiting: "requests.travel.awaitingHeading",
  sentNothing: "requests.travel.sentNothing",
  nothingAwaits: "requests.travel.nothingAwaits",
};
